// JsFromRoutes CacheKey b369abb0ccc9079692cd58e773caf41f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/'),
}
